export default __webpack_public_path__ + "static/media/spt7.f3981d42.png";